export class SearchItem {
    title: string;
    keywords: string;
    path: string;
    product: string;

    constructor(){};

}
